// import React, { useEffect, useState } from "react";
// import Header from "../../components/Header";
// import { useNavigate } from "react-router-dom";
// import classes from "./ZipGameProfile.module.css";
// import {
//   FaArrowLeft,
//   FaPen,
//   FaRightFromBracket,
//   FaChevronRight,
// } from "react-icons/fa6";
// import BottomNavbarZipGame from "../../components/ZipGame/BottomNavbarZipGame";
// import { useDispatch, useSelector } from "react-redux";
// import { removeUserZip } from "../../store/slices/userZipGameTokenSlice";
// import { zipUserProfileApi } from "../../http/http";

// const ZipGameProfile = () => {
//   const navigate = useNavigate();

//   const dispatch = useDispatch();

//   const { userZip } = useSelector(
//     (state) => state?.persisted?.userZipGameTokenSlice
//   );

//   const [userDetails, setUserDetails] = useState({});

//   const getInitials = (name) => {
//     if (!name) return "U";
//     return name
//       .split(" ")
//       .map((item) => item[0])
//       .join("")
//       .slice(0, 2)
//       .toUpperCase();
//   };

//   const handleLogout = () => {
//     dispatch(removeUserZip());
//     navigate("/");
//   };

//   const fetchUserProfile = async () => {
//     try {
//       const response = await zipUserProfileApi(userZip?.token);
//       console.log(response?.data?.result?.[0], 'd');
//       setUserDetails(response?.data?.result?.[0]);
//     } catch (error) {
//       console.log(error, 'error');
//     }
//   }

//   useEffect(() => {
//     fetchUserProfile();
//   }, []);

//   const formatMemberSince = (dateString) => {
//     if (!dateString) return "Member Since -";

//     const date = new Date(dateString);

//     if (isNaN(date.getTime())) return "Member Since -";

//     return `Member Since ${date.toLocaleString("en-US", {
//       month: "long",
//       year: "numeric",
//       timeZone: "UTC",
//     })}`;
//   };

//   return (
//     <>
//       <Header />

//         <div className={classes.container}>
//           <div className={classes.header_section}>
//             <button
//               className={classes.back_button}
//               onClick={() => navigate(-1)}
//               type="button"
//             >
//               <FaArrowLeft className={classes.back_icon} />
//             </button>

//             <p className={classes.header_title}>My Profile</p>
//           </div>

//           <div className={classes.profile_card}>
//             <div className={classes.profile_glow}></div>

//             <div className={classes.profile_top}>
//               <div className={classes.avatar_wrap}>
//                 <div className={classes.avatar_circle}>
//                   {getInitials(userDetails?.name)}
//                 </div>
//               </div>

//               <div className={classes.profile_info}>
//                 <p className={classes.player_name}>{userDetails?.name}</p>
//                 <p className={classes.player_role}>{userDetails?.msisdn}</p>

//               </div>
//             </div>

//             <button
//               type="button"
//               className={classes.edit_profile_btn}
//               onClick={() => navigate("/edit-profile")}
//             >
//               <FaPen />
//               Edit Profile
//             </button>
//           </div>

//           <div className={classes.section_card}>
//             <div className={classes.section_header}>
//               <p className={classes.section_title}>Quick Actions</p>
//             </div>

//             <div className={classes.action_list}>
//               <button
//                 type="button"
//                 className={classes.action_item}
//                 onClick={() => navigate("/zip-game-details")}
//               >
//                 <span>View Game History</span>
//                 <FaChevronRight className={classes.action_arrow} />
//               </button>

//               <button
//                 type="button"
//                 className={`${classes.action_item} ${classes.logout_button}`}
//                 onClick={handleLogout}
//               >
//                 <div className={classes.logout_inner}>
//                   <FaRightFromBracket />
//                   <span>Logout</span>
//                 </div>
//                 <FaChevronRight className={classes.action_arrow} />
//               </button>
//             </div>
//           </div>
//         </div>

//       <BottomNavbarZipGame active={4} />
//     </>
//   );
// };

// export default ZipGameProfile;



import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import classes from "./ZipGameProfile.module.css";
import {
  FaArrowLeft,
  FaPen,
  FaRightFromBracket,
  FaChevronRight,
  FaCalendarDays,
  FaIdBadge,
  FaCircleCheck,
} from "react-icons/fa6";
import BottomNavbarZipGame from "../../components/ZipGame/BottomNavbarZipGame";
import { useDispatch, useSelector } from "react-redux";
import { removeUserZip } from "../../store/slices/userZipGameTokenSlice";
import { zipUserProfileApi } from "../../http/http";
import ZipEditProfileModal from "../../components/ZipGame/ZipEditProfileModal";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const ZipGameProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {t}=useTranslation();

  const [modal, setModal] = useState(false);

  const { userZip } = useSelector(
    (state) => state?.persisted?.userZipGameTokenSlice
  );

  const [userDetails, setUserDetails] = useState({});
  const [imageError, setImageError] = useState(false);

  const [loading, setLoading] = useState(false);

  const getInitials = (name) => {
    if (!name) return "U";
    return name
      .trim()
      .split(" ")
      .filter(Boolean)
      .map((item) => item[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  const handleLogout = () => {
    dispatch(removeUserZip());
    navigate("/");
  };

  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      const response = await zipUserProfileApi(userZip?.token);
      setUserDetails(response?.data?.result?.[0] || {});

    } catch (error) {
      toast.error(t("86"));
      console.log(error, "error");
    }
    finally {
      setLoading(false);
    }
  };

  console.log(userDetails, 'userDetails..');

  useEffect(() => {
    if (userZip?.token) {
      fetchUserProfile();
    }
  }, [userZip?.token]);

  const formatMemberSince = (dateString) => {
    if (!dateString) return t("227");

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return t("227");

    return `${t("228")} ${date.toLocaleString("en-US", {
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    })}`;
  };

  const formatJoinedMonth = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "-";

    return date.toLocaleString("en-US", {
      month: "short",
      year: "numeric",
      timeZone: "UTC",
    });
  };

  return (
    <>
      <Header />

      <div className={classes.container}>
        <div className={classes.header_section}>
          <button
            className={classes.back_button}
            onClick={() => navigate(-1)}
            type="button"
          >
            <FaArrowLeft className={classes.back_icon} />
          </button>

          <p className={classes.header_title}>{t("229")}</p>
        </div>

        {loading ?
          <div className={classes.state_card}>
            <div className={classes.loader}></div>
            {/* <p className={classes.state_text}>Loading...</p> */}
          </div>
          : (
            <>
              <div className={classes.profile_card}>
                <div className={classes.profile_blur_one}></div>
                <div className={classes.profile_blur_two}></div>
                <div className={classes.profile_ring}></div>

                <div className={classes.profile_top}>
                  <div className={classes.avatar_outer}>
                    <div className={classes.avatar_inner}>
                      {userDetails?.image && !imageError ? (
                        <img
                          src={userDetails?.image}
                          alt={userDetails?.name || "Profile"}
                          className={classes.avatar_image}
                          onError={() => setImageError(true)}
                        />
                      ) : (
                        <div className={classes.avatar_circle}>
                          {getInitials(userDetails?.name)}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={classes.profile_info}>
                    <p className={classes.profile_tag}>{t("230")}</p>
                    <p className={classes.player_name}>
                      {userDetails?.name || "Player"}
                    </p>

                    <div className={classes.profile_meta_row}>
                      <span className={classes.msisdn_badge}>
                        {userDetails?.msisdn || "-"}
                      </span>
                    </div>

                    <p className={classes.member_since_text}>
                      {formatMemberSince(userDetails?.register_date_time)}
                    </p>
                  </div>
                </div>

                <div className={classes.profile_stats_row}>
                  <div className={classes.mini_stat_card}>
                    <div className={classes.mini_stat_icon}>
                      <FaIdBadge />
                    </div>
                    <div className={classes.mini_stat_content}>
                      <p className={classes.mini_stat_label}>{t("231")}</p>
                      <p className={classes.mini_stat_value}>
                        {userDetails?.msisdn || "-"}
                      </p>
                    </div>
                  </div>

                  <div className={classes.mini_stat_card}>
                    <div className={classes.mini_stat_icon}>
                      <FaCircleCheck />
                    </div>
                    <div className={classes.mini_stat_content}>
                      <p className={classes.mini_stat_label}>{t("232")}</p>
                      <p className={classes.mini_stat_value}>
                        {userDetails?.status === 1 ? t("233") : t("234")}
                      </p>
                    </div>
                  </div>

                  <div className={classes.mini_stat_card}>
                    <div className={classes.mini_stat_icon}>
                      <FaCalendarDays />
                    </div>
                    <div className={classes.mini_stat_content}>
                      <p className={classes.mini_stat_label}>{t("235")}</p>
                      <p className={classes.mini_stat_value}>
                        {formatJoinedMonth(userDetails?.register_date_time)}
                      </p>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  className={classes.edit_profile_btn}
                  onClick={() => setModal(true)}
                >
                  <FaPen />
                  {t("236")}
                </button>
              </div>

              <div className={classes.section_card}>
                <div className={classes.section_header}>
                  <p className={classes.section_title}>{t("237")}</p>
                </div>

                <div className={classes.action_list}>
                  <button
                    type="button"
                    className={classes.action_item}
                    onClick={() => navigate("/zip-game/history")}
                  >
                    <span>{t("238")}</span>
                    <FaChevronRight className={classes.action_arrow} />
                  </button>

                  <button
                    type="button"
                    className={`${classes.action_item} ${classes.logout_button}`}
                    onClick={handleLogout}
                  >
                    <div className={classes.logout_inner}>
                      <FaRightFromBracket />
                      <span>{t("239")}</span>
                    </div>
                    <FaChevronRight className={classes.action_arrow} />
                  </button>
                </div>
              </div>
            </>
          )}


      </div>

      <BottomNavbarZipGame active={4} />

      <ZipEditProfileModal
        modal={modal}
        setModal={setModal}
        name={userDetails?.name}
        image={userDetails?.image}
        fetchUserProfile={fetchUserProfile}
      />
    </>
  );
};

export default ZipGameProfile;